import { createSlice } from '@reduxjs/toolkit';
import {
  createConsultation,
  deleteConsultation,
  fetchConsultations,
  fetchConsultationTypes,
  updateConsultation,
} from './actions';
import { Consultation, ConsultationType } from './models';

export interface ConsultationState {
  consultations: Consultation[];
  consultationTypes: ConsultationType[];
  loadingConsultations: boolean;
  loadingCreateConsultation: boolean;
}

const initialState: ConsultationState = {
  consultations: [],
  consultationTypes: [],
  loadingConsultations: false,
  loadingCreateConsultation: false,
};

const consultationSlice = createSlice({
  name: 'consultation',
  initialState,
  reducers: {
    clearConsultations: (state) => {
      state.consultations = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchConsultations.pending, (state) => {
        state.loadingConsultations = true;
      })
      .addCase(fetchConsultations.fulfilled, (state, action) => {
        state.consultations = action.payload;
        state.loadingConsultations = false;
      })
      .addCase(fetchConsultations.rejected, (state) => {
        state.loadingConsultations = false;
      })
      .addCase(createConsultation.pending, (state) => {
        state.loadingCreateConsultation = true;
      })
      .addCase(createConsultation.rejected, (state) => {
        state.loadingCreateConsultation = false;
      })
      .addCase(createConsultation.fulfilled, (state) => {
        state.loadingCreateConsultation = false;
      })
      .addCase(updateConsultation.fulfilled, (state, action) => {
        const updatedSymptoms = state.consultations.map((consultation) =>
          consultation.id === action.payload.id ? action.payload : consultation
        );
        state.consultations = updatedSymptoms;
      })
      .addCase(fetchConsultationTypes.fulfilled, (state, action) => {
        state.consultationTypes = action.payload;
      })
      .addCase(deleteConsultation.fulfilled, (state, action) => {
        state.consultations = state.consultations.filter(
          (item) => item.id !== action.meta.arg
        );
      });
  },
});

export default consultationSlice.reducer;

export const { clearConsultations } = consultationSlice.actions;
